import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { analisarHemodinamica } from './helpers';

export default function TiltTestBarChart({ chartData }) {
  const analise = analisarHemodinamica(chartData);

  return (
    <div style={{ width: '100%', maxWidth: '100%', marginTop: 20 }}>
      <h6>Tilt Test - Gráfico Hemodinâmico</h6>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} margin={{ top: 20, right: 10, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="periodo" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Bar dataKey="PAS" fill="#ff0000" name="PAS (mmHg)" />
          <Bar dataKey="PAD" fill="#0000ff" name="PAD (mmHg)" />
          <Bar dataKey="FC" fill="#00cc00" name="FC (bpm)" />
        </BarChart>
      </ResponsiveContainer>

      <hr />

      {analise && (
        <div style={{ marginTop: 10 }}>
          <h6>Análise da Resposta Hemodinâmica</h6>
          <ul>
            <li>
              <strong>Variação PAS:</strong> {analise.pas.inicio} - {analise.pas.fim} mmHg (
              {analise.pas.variacao} mmHg) → {analise.pas.analise}
            </li>
            <li>
              <strong>Variação PAD:</strong> {analise.pad.inicio} - {analise.pad.fim} mmHg (
              {analise.pad.variacao} mmHg) → {analise.pad.analise}
            </li>
            <li>
              <strong>Variação FC:</strong> {analise.fc.inicio} - {analise.fc.fim} bpm (
              {analise.fc.variacao} bpm) → {analise.fc.analise}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
